import React from "react";
import { Handshake, Compass, FolderOpen, MailCheck, FileBadge, GraduationCap, ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LangContext";
import { howWeWorkI18n } from "../i18n/howwework_i18n";

const ICONS = [Handshake, Compass, FolderOpen, MailCheck, FileBadge, GraduationCap];

const HowWeWork = () => {
  const { lang } = useLang();
  const i18n = howWeWorkI18n[lang] || howWeWorkI18n.ru;
  const isRtl = lang === 'ar';

  return (
    <section className="py-20 md:py-28" style={{ background: '#FAF8F5' }} dir={isRtl ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="eyebrow mb-3">{i18n.eyebrow}</div>
          <h2 className="headline-huge text-3xl md:text-5xl text-balance" style={{ color: '#1B2A4A' }}>{i18n.title}</h2>
          <p className="mt-4 text-base md:text-lg" style={{ color: '#666666' }}>{i18n.subtitle}</p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-7 left-0 right-0 h-px" style={{ background: 'linear-gradient(to right, transparent 0%, #C9A96E 8%, #C9A96E 92%, transparent 100%)' }} />

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 md:gap-5">
            {i18n.steps.map((s, i) => {
              const Icon = ICONS[i];
              return (
                <div key={i} className="relative text-center" data-testid={`step-${i+1}`}>
                  <div className="relative z-10 mx-auto w-14 h-14 rounded-full flex items-center justify-center font-display text-lg font-semibold mb-5 shadow-md" style={{ background: '#1B2A4A', color: '#fff' }}>
                    {String(i + 1).padStart(2, '0')}
                  </div>
                  <Icon className="w-7 h-7 mx-auto mb-4" strokeWidth={1.5} style={{ color: '#C9A96E' }} />
                  <h3 className="font-display text-base md:text-lg font-semibold mb-2" style={{ color: '#1B2A4A' }}>{s.title}</h3>
                  <p className="text-sm leading-relaxed px-2" style={{ color: '#666666' }}>{s.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
